//@flow
import React from 'react';
import {Switch, Route} from 'react-router-dom';
import {makeStyles} from '@material-ui/core';
import CrmSegmentSummary from './crm-segment-summary';
import CrmSegmentManualForm from './crm-segment-form/crm-segment-manual-form';

import CrmSegmentDynamicForm from './crm-segment-form/crm-segment-dynamic-form';

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'black',
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px',
    },
  },
  navBackground: {
    [theme.breakpoints.down('sm')]: {
      background: 'white !important',
    },
  },

  modalTitle: {
    fontSize: '1.25rem',
    fontWeight: 600,
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    marginBlock: '.75rem',

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  modalContainer: {
    maxWidth: '550px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '.5rem',
  },
}));

export default function CrmSegment() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Switch>
        <Route exact path="/segments" component={CrmSegmentSummary}></Route>
        <Route
          path="/segments/manual/:id"
          component={CrmSegmentManualForm}
        ></Route>
        <Route
          path="/segments/dynamic/:id"
          component={CrmSegmentDynamicForm}
        ></Route>
      </Switch>
    </div>
  );
}
